import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';

export type UpdateOrdersInstrumentAction = {
    type: 'updateOrdersInstrument' | 'linkingUpdateOrdersInstrument';
    tabId: string;
    instrument: Instrument;
};
export const updateOrdersInstrument = (
    tabId: string,
    instrument: Instrument,
    isLinking = false,
): UpdateOrdersInstrumentAction => ({
    tabId,
    instrument,
    type: isLinking ? 'linkingUpdateOrdersInstrument' : 'updateOrdersInstrument',
});

export type UpdateOrdersIsManualReviewSoundAlertEnabledAction = {
    type: 'updateOrdersIsManualReviewSoundAlertEnabled';
    tabId: string;
    isManualReviewSoundAlertEnabled: boolean;
};
export const updateOrdersIsManualReviewSoundAlertEnabled = (
    tabId: string,
    isManualReviewSoundAlertEnabled: boolean,
): UpdateOrdersIsManualReviewSoundAlertEnabledAction => ({
    tabId,
    isManualReviewSoundAlertEnabled,
    type: 'updateOrdersIsManualReviewSoundAlertEnabled',
});

export type UpdateOrdersAccountAction = {
    type: 'updateOrdersAccount';
    tabId: string;
    accountId: string | null;
};
export const updateOrdersAccount = (tabId: string, accountId: string): UpdateOrdersAccountAction => ({
    tabId,
    accountId,
    type: 'updateOrdersAccount',
});

export type UserDoubleClickedOrderFromTableAction = {
    type: 'userDoubleClickedOrderFromTable';
    symbol?: string;
    accountId?: string;
    tabId: string;
};

export const userDoubleClickedOrder = (
    tabId: string,
    symbol?: string,
    accountId?: string,
): UserDoubleClickedOrderFromTableAction => ({
    symbol,
    accountId,
    tabId,
    type: 'userDoubleClickedOrderFromTable',
});

export type OrdersActions =
    | UpdateOrdersInstrumentAction
    | UpdateOrdersAccountAction
    | UserDoubleClickedOrderFromTableAction
    | UpdateOrdersIsManualReviewSoundAlertEnabledAction;
